import { render, staticRenderFns } from "./CustomerViewEstimates.vue?vue&type=template&id=79837f04"
import script from "./CustomerViewEstimates.vue?vue&type=script&lang=js"
export * from "./CustomerViewEstimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports